import React from "react";

const Footer = () => {
  return (
    <footer className="z-10 flex items-center bg-white p-4 md:p-6 lg:px-[2vw] 2xl:py-6">
      <p className="text-sm uppercase">
        © 2024 Passepartout4u P.IVA 07054850966
      </p>
    </footer>
  );
};

export default Footer;
